// Where the admin dashboard is mounted. This app is its own standalone
// deployment (its own origin — see ../README.md), not nested under a
// /admin path inside a shared server, so it owns its whole origin's root.

export const HOME_PATH = '/';
